export const contentTableConfig = {
  propList: [
    { prop: 'serialNumber', label: '编号', width: '100', fixed: true},
    { prop: 'unionid', label: '客户编码', width: '320' },
    { prop: 'customCode', label: '客户微信', width: '320' },
    { prop: 'nickName', label: '微信昵称', width: '160', sortable: 'custom'},
    { prop: 'employeeUserId', label: '工作微信号', width: '120', slotName:'proofImgUrls' },
    { prop: 'employeeWechatCode', label: '工作号姓名', width: '100', slotName: 'recordingUrls' },
    { prop: 'phoneNumber', label: '对应手机号', width: '120' },
    { prop: 'department', label: '所属部门', width: '120' },
    { prop: 'mainBody', label: '所属主体', width: '180' },
    { prop: 'createUser', label: '开单人', width: '100' },
    { prop: 'channel', label: '开单渠道', width: '100', slotName: 'channel' },
    { prop: 'peerStatus', label: '同行或成交', width: '100', slotName: 'peerStatus' },
    { prop: 'peerInfo', label: '同行类别', width: '100' },
    { prop: 'exist', label: '是否重复', width: '120', fixed: 'right', slotName: 'exist' },
    { prop: 'updateUser', label: '编辑人', width: '100', fixed: 'right' },
    { prop: 'addTime', label: '录入时间', width: '120', fixed: 'right'}
  ],
  showSelectColumn: true
}
